import { Switch } from '@components/Switch/Switch';
import { ActionButton } from '@pages/ActionButton';
import { debugStore } from '@stores/Debug';
import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export const MobileDebugOnPage = observer(() => {
  const navigate = useNavigate();

  useEffect(() => {
    debugStore.setRespectfulDebugMode(true);
    debugStore.setMobileUI(true);
  }, []);

  return (
    <div
      style={{
        width: '100vw',
        height: '100dvh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 24,
        color: 'rgba(193, 193, 194, 1)',
        fontSize: 18,
      }}
    >
      Mobile Debug On
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <label style={{ color: 'rgba(193, 193, 194, 1)', fontSize: 14 }}>
          Show center line on search
        </label>
        <Switch
          checked={debugStore.showCenterLine}
          onChange={(checked) => debugStore.setShowCenterLine(checked)}
        />
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <label style={{ color: 'rgba(193, 193, 194, 1)', fontSize: 14 }}>
          Force isFirstTimeUser true
        </label>
        <Switch
          checked={debugStore.forceFirstTimeUser}
          onChange={(checked) => debugStore.setForceFirstTimeUser(checked)}
        />
      </div>
      <ActionButton onClick={() => navigate('/')}>Return to home</ActionButton>
    </div>
  );
});

export const MobileDebugOffPage = observer(() => {
  const navigate = useNavigate();

  useEffect(() => {
    debugStore.setMobileUI(false);
  }, []);

  return (
    <div
      style={{
        width: '100vw',
        height: '100dvh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 24,
        color: 'rgba(193, 193, 194, 1)',
        fontSize: 18,
      }}
    >
      Mobile Debug Off
      <ActionButton
        onClick={() => {
          debugStore.setRespectfulDebugMode(false);
        }}
      >
        Exit debug mode
      </ActionButton>
      <ActionButton onClick={() => navigate('/')}>Return to home</ActionButton>
    </div>
  );
});
